// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/proposal_pricing.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.datagateway.v1.ProposalPricingClinItem
 */ export class ProposalPricingClinItem extends Message {
    static fromBinary(bytes, options) {
        return new ProposalPricingClinItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalPricingClinItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalPricingClinItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalPricingClinItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string item_id = 1;
   */ _define_property(this, "itemId", ""), /**
   * @generated from field: string clin_number = 2;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string data_json = 3;
   */ _define_property(this, "dataJson", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalPricingClinItem, "runtime", proto3);
_define_property(ProposalPricingClinItem, "typeName", "mono.datagateway.v1.ProposalPricingClinItem");
_define_property(ProposalPricingClinItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "data_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposalPricingScenario
 */ export class ProposalPricingScenario extends Message {
    static fromBinary(bytes, options) {
        return new ProposalPricingScenario().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalPricingScenario().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalPricingScenario().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalPricingScenario, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string scenario_id = 1;
   */ _define_property(this, "scenarioId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string tenant_id = 3;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string scenario_name = 4;
   */ _define_property(this, "scenarioName", ""), /**
   * @generated from field: bool is_primary = 5;
   */ _define_property(this, "isPrimary", false), /**
   * The legacy full JSON blob, kept beside the normalized form.
   *
   * @generated from field: string data = 6;
   */ _define_property(this, "data", ""), /**
   * @generated from field: string global_config = 7;
   */ _define_property(this, "globalConfig", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalPricingClinItem items = 10;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalPricingScenario, "runtime", proto3);
_define_property(ProposalPricingScenario, "typeName", "mono.datagateway.v1.ProposalPricingScenario");
_define_property(ProposalPricingScenario, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scenario_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "is_primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "data",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "global_config",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "items",
            kind: "message",
            T: ProposalPricingClinItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPricingScenariosRequest
 */ export class ListPricingScenariosRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPricingScenariosRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPricingScenariosRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPricingScenariosRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPricingScenariosRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPricingScenariosRequest, "runtime", proto3);
_define_property(ListPricingScenariosRequest, "typeName", "mono.datagateway.v1.ListPricingScenariosRequest");
_define_property(ListPricingScenariosRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPricingScenariosResponse
 */ export class ListPricingScenariosResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPricingScenariosResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPricingScenariosResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPricingScenariosResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPricingScenariosResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalPricingScenario scenarios = 1;
   */ _define_property(this, "scenarios", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPricingScenariosResponse, "runtime", proto3);
_define_property(ListPricingScenariosResponse, "typeName", "mono.datagateway.v1.ListPricingScenariosResponse");
_define_property(ListPricingScenariosResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scenarios",
            kind: "message",
            T: ProposalPricingScenario,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPricingScenarioRequest
 */ export class GetPricingScenarioRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPricingScenarioRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPricingScenarioRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPricingScenarioRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPricingScenarioRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 3;
   */ _define_property(this, "scenarioId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPricingScenarioRequest, "runtime", proto3);
_define_property(GetPricingScenarioRequest, "typeName", "mono.datagateway.v1.GetPricingScenarioRequest");
_define_property(GetPricingScenarioRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPricingScenarioResponse
 */ export class GetPricingScenarioResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPricingScenarioResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPricingScenarioResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPricingScenarioResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPricingScenarioResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalPricingScenario scenario = 1;
   */ _define_property(this, "scenario", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPricingScenarioResponse, "runtime", proto3);
_define_property(GetPricingScenarioResponse, "typeName", "mono.datagateway.v1.GetPricingScenarioResponse");
_define_property(GetPricingScenarioResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scenario",
            kind: "message",
            T: ProposalPricingScenario
        }
    ]));
/**
 * scenario carries the id, project, name, data, global_config and items;
 * is_primary is assigned.
 *
 * @generated from message mono.datagateway.v1.CreatePricingScenarioRequest
 */ export class CreatePricingScenarioRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreatePricingScenarioRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePricingScenarioRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePricingScenarioRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePricingScenarioRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: mono.datagateway.v1.ProposalPricingScenario scenario = 2;
   */ _define_property(this, "scenario", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePricingScenarioRequest, "runtime", proto3);
_define_property(CreatePricingScenarioRequest, "typeName", "mono.datagateway.v1.CreatePricingScenarioRequest");
_define_property(CreatePricingScenarioRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scenario",
            kind: "message",
            T: ProposalPricingScenario
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreatePricingScenarioResponse
 */ export class CreatePricingScenarioResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreatePricingScenarioResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePricingScenarioResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePricingScenarioResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePricingScenarioResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalPricingScenario scenario = 1;
   */ _define_property(this, "scenario", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePricingScenarioResponse, "runtime", proto3);
_define_property(CreatePricingScenarioResponse, "typeName", "mono.datagateway.v1.CreatePricingScenarioResponse");
_define_property(CreatePricingScenarioResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scenario",
            kind: "message",
            T: ProposalPricingScenario
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdatePricingScenarioRequest
 */ export class UpdatePricingScenarioRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePricingScenarioRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePricingScenarioRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePricingScenarioRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePricingScenarioRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 3;
   */ _define_property(this, "scenarioId", ""), /**
   * @generated from field: optional string scenario_name = 4;
   */ _define_property(this, "scenarioName", void 0), /**
   * @generated from field: optional bool is_primary = 5;
   */ _define_property(this, "isPrimary", void 0), /**
   * @generated from field: string data = 6;
   */ _define_property(this, "data", ""), /**
   * @generated from field: string global_config = 7;
   */ _define_property(this, "globalConfig", ""), /**
   * @generated from field: bool replace_items = 8;
   */ _define_property(this, "replaceItems", false), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalPricingClinItem items = 9;
   */ _define_property(this, "items", []), /**
   * PRP-13 CAS: when set, the write is refused (FailedPrecondition) unless it equals the
   * scenario's updated_at (RFC3339Nano) under the row lock.
   *
   * @generated from field: optional string expected_updated_at = 10;
   */ _define_property(this, "expectedUpdatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePricingScenarioRequest, "runtime", proto3);
_define_property(UpdatePricingScenarioRequest, "typeName", "mono.datagateway.v1.UpdatePricingScenarioRequest");
_define_property(UpdatePricingScenarioRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scenario_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 5,
            name: "is_primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 6,
            name: "data",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "global_config",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "replace_items",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "items",
            kind: "message",
            T: ProposalPricingClinItem,
            repeated: true
        },
        {
            no: 10,
            name: "expected_updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * The scenario as written, items included.
 *
 * @generated from message mono.datagateway.v1.UpdatePricingScenarioResponse
 */ export class UpdatePricingScenarioResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePricingScenarioResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePricingScenarioResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePricingScenarioResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePricingScenarioResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalPricingScenario scenario = 1;
   */ _define_property(this, "scenario", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePricingScenarioResponse, "runtime", proto3);
_define_property(UpdatePricingScenarioResponse, "typeName", "mono.datagateway.v1.UpdatePricingScenarioResponse");
_define_property(UpdatePricingScenarioResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scenario",
            kind: "message",
            T: ProposalPricingScenario
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeletePricingScenarioRequest
 */ export class DeletePricingScenarioRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeletePricingScenarioRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePricingScenarioRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePricingScenarioRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePricingScenarioRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 3;
   */ _define_property(this, "scenarioId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePricingScenarioRequest, "runtime", proto3);
_define_property(DeletePricingScenarioRequest, "typeName", "mono.datagateway.v1.DeletePricingScenarioRequest");
_define_property(DeletePricingScenarioRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeletePricingScenarioResponse
 */ export class DeletePricingScenarioResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeletePricingScenarioResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePricingScenarioResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePricingScenarioResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePricingScenarioResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePricingScenarioResponse, "runtime", proto3);
_define_property(DeletePricingScenarioResponse, "typeName", "mono.datagateway.v1.DeletePricingScenarioResponse");
_define_property(DeletePricingScenarioResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * PricingScenarioVersion is one immutable snapshot. items_json is a JSON array
 * of {item_id, clin_number, position, data_json}; pinned_selections_json is a
 * JSON array of {selection_id, consumer_ref, observation_id,
 * observation_version, observation_amount, selected_amount, applicability,
 * assumptions} as they stood when the snapshot was taken.
 *
 * @generated from message mono.datagateway.v1.PricingScenarioVersion
 */ export class PricingScenarioVersion extends Message {
    static fromBinary(bytes, options) {
        return new PricingScenarioVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingScenarioVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingScenarioVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingScenarioVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string total_contract_value = 12;
   */ _define_property(this, "totalContractValue", ""), /**
   * @generated from field: string workbook_document_version_id = 13;
   */ _define_property(this, "workbookDocumentVersionId", ""), /**
   * @generated from field: string version_id = 1;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string scenario_id = 2;
   */ _define_property(this, "scenarioId", ""), /**
   * @generated from field: int32 version_no = 3;
   */ _define_property(this, "versionNo", 0), /**
   * @generated from field: bool frozen = 4;
   */ _define_property(this, "frozen", false), /**
   * @generated from field: string scenario_name = 5;
   */ _define_property(this, "scenarioName", ""), /**
   * @generated from field: string data = 6;
   */ _define_property(this, "data", ""), /**
   * @generated from field: string global_config = 7;
   */ _define_property(this, "globalConfig", ""), /**
   * @generated from field: string items_json = 8;
   */ _define_property(this, "itemsJson", ""), /**
   * @generated from field: string pinned_selections_json = 9;
   */ _define_property(this, "pinnedSelectionsJson", ""), /**
   * @generated from field: string created_by = 10;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string pricing_type = 14;
   */ _define_property(this, "pricingType", ""), /**
   * @generated from field: string totals_json = 15;
   */ _define_property(this, "totalsJson", ""), /**
   * @generated from field: string suggestions_json = 16;
   */ _define_property(this, "suggestionsJson", ""), /**
   * @generated from field: string lcat_links_json = 17;
   */ _define_property(this, "lcatLinksJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingScenarioVersion, "runtime", proto3);
_define_property(PricingScenarioVersion, "typeName", "mono.datagateway.v1.PricingScenarioVersion");
_define_property(PricingScenarioVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 12,
            name: "total_contract_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "workbook_document_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 1,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_no",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "frozen",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "scenario_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "data",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "global_config",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "items_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "pinned_selections_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "pricing_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "totals_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "suggestions_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "lcat_links_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * PricingWorkbook: reconciliation_status is MAPPED or UNAVAILABLE.
 * revised_version_id is the latest revised workbook version, empty if none.
 *
 * @generated from message mono.datagateway.v1.PricingWorkbook
 */ export class PricingWorkbook extends Message {
    static fromBinary(bytes, options) {
        return new PricingWorkbook().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingWorkbook().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingWorkbook().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingWorkbook, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string binding_kind = 11;
   */ _define_property(this, "bindingKind", ""), /**
   * @generated from field: string shirohige_document_id = 12;
   */ _define_property(this, "shirohigeDocumentId", ""), /**
   * @generated from field: string volume_document_id = 13;
   */ _define_property(this, "volumeDocumentId", ""), /**
   * @generated from field: string last_filled_version_id = 14;
   */ _define_property(this, "lastFilledVersionId", ""), /**
   * @generated from field: string last_filled_from_version_id = 15;
   */ _define_property(this, "lastFilledFromVersionId", ""), /**
   * @generated from field: string last_read_version_id = 16;
   */ _define_property(this, "lastReadVersionId", ""), /**
   * @generated from field: google.protobuf.Timestamp unbound_at = 17;
   */ _define_property(this, "unboundAt", void 0), /**
   * @generated from field: string workbook_id = 1;
   */ _define_property(this, "workbookId", ""), /**
   * @generated from field: string scenario_id = 2;
   */ _define_property(this, "scenarioId", ""), /**
   * @generated from field: string artifact_id = 3;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string original_version_id = 4;
   */ _define_property(this, "originalVersionId", ""), /**
   * @generated from field: string revised_version_id = 5;
   */ _define_property(this, "revisedVersionId", ""), /**
   * @generated from field: string mapping_json = 6;
   */ _define_property(this, "mappingJson", ""), /**
   * @generated from field: string reconciliation_status = 7;
   */ _define_property(this, "reconciliationStatus", ""), /**
   * @generated from field: string created_by = 8;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingWorkbook, "runtime", proto3);
_define_property(PricingWorkbook, "typeName", "mono.datagateway.v1.PricingWorkbook");
_define_property(PricingWorkbook, "fields", proto3.util.newFieldList(()=>[
        {
            no: 11,
            name: "binding_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "shirohige_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "volume_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "last_filled_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "last_filled_from_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "last_read_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "unbound_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 1,
            name: "workbook_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "original_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "revised_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "mapping_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reconciliation_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * PricingReconciliationProposal: status is PENDING, ACCEPTED or REJECTED.
 * proposed_diff_json is a JSON object whose present keys replace the scenario's
 * "data" (string), "global_config" (string) and "items" (array of
 * {item_id, clin_number, data_json}).
 *
 * @generated from message mono.datagateway.v1.PricingReconciliationProposal
 */ export class PricingReconciliationProposal extends Message {
    static fromBinary(bytes, options) {
        return new PricingReconciliationProposal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingReconciliationProposal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingReconciliationProposal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingReconciliationProposal, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string proposal_id = 1;
   */ _define_property(this, "proposalId", ""), /**
   * @generated from field: string scenario_id = 2;
   */ _define_property(this, "scenarioId", ""), /**
   * @generated from field: string workbook_id = 3;
   */ _define_property(this, "workbookId", ""), /**
   * @generated from field: string base_scenario_version_id = 4;
   */ _define_property(this, "baseScenarioVersionId", ""), /**
   * @generated from field: string original_workbook_version_id = 5;
   */ _define_property(this, "originalWorkbookVersionId", ""), /**
   * @generated from field: string revised_workbook_version_id = 6;
   */ _define_property(this, "revisedWorkbookVersionId", ""), /**
   * @generated from field: string proposed_diff_json = 7;
   */ _define_property(this, "proposedDiffJson", ""), /**
   * @generated from field: string status = 8;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string resulting_version_id = 9;
   */ _define_property(this, "resultingVersionId", ""), /**
   * @generated from field: string created_by = 10;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string resolved_by = 12;
   */ _define_property(this, "resolvedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp resolved_at = 13;
   */ _define_property(this, "resolvedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingReconciliationProposal, "runtime", proto3);
_define_property(PricingReconciliationProposal, "typeName", "mono.datagateway.v1.PricingReconciliationProposal");
_define_property(PricingReconciliationProposal, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workbook_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "base_scenario_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "original_workbook_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "revised_workbook_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "proposed_diff_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "resulting_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "resolved_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "resolved_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * PricingRateSelection is a live active Rate Book selection pinned to the
 * scenario. review_status is "", CORRECTED, INVALIDATED or NEWER_EVIDENCE.
 *
 * @generated from message mono.datagateway.v1.PricingRateSelection
 */ export class PricingRateSelection extends Message {
    static fromBinary(bytes, options) {
        return new PricingRateSelection().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingRateSelection().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingRateSelection().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingRateSelection, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string selection_id = 1;
   */ _define_property(this, "selectionId", ""), /**
   * @generated from field: string consumer_ref = 2;
   */ _define_property(this, "consumerRef", ""), /**
   * @generated from field: string observation_id = 3;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: int32 observation_version = 4;
   */ _define_property(this, "observationVersion", 0), /**
   * @generated from field: double observation_amount = 5;
   */ _define_property(this, "observationAmount", 0), /**
   * @generated from field: double selected_amount = 6;
   */ _define_property(this, "selectedAmount", 0), /**
   * @generated from field: string applicability = 7;
   */ _define_property(this, "applicability", ""), /**
   * @generated from field: string assumptions = 8;
   */ _define_property(this, "assumptions", ""), /**
   * @generated from field: string review_status = 9;
   */ _define_property(this, "reviewStatus", ""), /**
   * @generated from field: double review_candidate_amount = 10;
   */ _define_property(this, "reviewCandidateAmount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingRateSelection, "runtime", proto3);
_define_property(PricingRateSelection, "typeName", "mono.datagateway.v1.PricingRateSelection");
_define_property(PricingRateSelection, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "selection_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "consumer_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "observation_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "observation_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "selected_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "applicability",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "assumptions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "review_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "review_candidate_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SnapshotPricingScenarioVersionRequest
 */ export class SnapshotPricingScenarioVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SnapshotPricingScenarioVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SnapshotPricingScenarioVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SnapshotPricingScenarioVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SnapshotPricingScenarioVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 3;
   */ _define_property(this, "scenarioId", ""), /**
   * @generated from field: string actor = 4;
   */ _define_property(this, "actor", ""), /**
   * Compatibility inputs only; the gateway recomputes financial evidence from the locked head.
   *
   * @generated from field: string total_contract_value = 5;
   */ _define_property(this, "totalContractValue", ""), /**
   * @generated from field: string pricing_type = 6;
   */ _define_property(this, "pricingType", ""), /**
   * @generated from field: string totals_json = 7;
   */ _define_property(this, "totalsJson", ""), /**
   * @generated from field: string suggestions_json = 8;
   */ _define_property(this, "suggestionsJson", ""), /**
   * @generated from field: string lcat_links_json = 9;
   */ _define_property(this, "lcatLinksJson", ""), /**
   * @generated from field: string workbook_document_version_id = 10;
   */ _define_property(this, "workbookDocumentVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SnapshotPricingScenarioVersionRequest, "runtime", proto3);
_define_property(SnapshotPricingScenarioVersionRequest, "typeName", "mono.datagateway.v1.SnapshotPricingScenarioVersionRequest");
_define_property(SnapshotPricingScenarioVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "total_contract_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "pricing_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "totals_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "suggestions_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "lcat_links_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "workbook_document_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SnapshotPricingScenarioVersionResponse
 */ export class SnapshotPricingScenarioVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SnapshotPricingScenarioVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SnapshotPricingScenarioVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SnapshotPricingScenarioVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SnapshotPricingScenarioVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PricingScenarioVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SnapshotPricingScenarioVersionResponse, "runtime", proto3);
_define_property(SnapshotPricingScenarioVersionResponse, "typeName", "mono.datagateway.v1.SnapshotPricingScenarioVersionResponse");
_define_property(SnapshotPricingScenarioVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: PricingScenarioVersion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPricingWorkbookByDocumentRequest
 */ export class GetPricingWorkbookByDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPricingWorkbookByDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPricingWorkbookByDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPricingWorkbookByDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPricingWorkbookByDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string shirohige_document_id = 2;
   */ _define_property(this, "shirohigeDocumentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPricingWorkbookByDocumentRequest, "runtime", proto3);
_define_property(GetPricingWorkbookByDocumentRequest, "typeName", "mono.datagateway.v1.GetPricingWorkbookByDocumentRequest");
_define_property(GetPricingWorkbookByDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "shirohige_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPricingWorkbookByDocumentResponse
 */ export class GetPricingWorkbookByDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPricingWorkbookByDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPricingWorkbookByDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPricingWorkbookByDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPricingWorkbookByDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PricingWorkbook workbook = 1;
   */ _define_property(this, "workbook", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPricingWorkbookByDocumentResponse, "runtime", proto3);
_define_property(GetPricingWorkbookByDocumentResponse, "typeName", "mono.datagateway.v1.GetPricingWorkbookByDocumentResponse");
_define_property(GetPricingWorkbookByDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workbook",
            kind: "message",
            T: PricingWorkbook
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnbindPricingWorkbookRequest
 */ export class UnbindPricingWorkbookRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnbindPricingWorkbookRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnbindPricingWorkbookRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnbindPricingWorkbookRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnbindPricingWorkbookRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string workbook_id = 3;
   */ _define_property(this, "workbookId", ""), /**
   * @generated from field: string actor = 4;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnbindPricingWorkbookRequest, "runtime", proto3);
_define_property(UnbindPricingWorkbookRequest, "typeName", "mono.datagateway.v1.UnbindPricingWorkbookRequest");
_define_property(UnbindPricingWorkbookRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workbook_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnbindPricingWorkbookResponse
 */ export class UnbindPricingWorkbookResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnbindPricingWorkbookResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnbindPricingWorkbookResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnbindPricingWorkbookResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnbindPricingWorkbookResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PricingWorkbook workbook = 1;
   */ _define_property(this, "workbook", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnbindPricingWorkbookResponse, "runtime", proto3);
_define_property(UnbindPricingWorkbookResponse, "typeName", "mono.datagateway.v1.UnbindPricingWorkbookResponse");
_define_property(UnbindPricingWorkbookResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workbook",
            kind: "message",
            T: PricingWorkbook
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegisterPricingWorkbookRequest
 */ export class RegisterPricingWorkbookRequest extends Message {
    static fromBinary(bytes, options) {
        return new RegisterPricingWorkbookRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegisterPricingWorkbookRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegisterPricingWorkbookRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegisterPricingWorkbookRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 3;
   */ _define_property(this, "scenarioId", ""), /**
   * @generated from field: string workbook_id = 4;
   */ _define_property(this, "workbookId", ""), /**
   * @generated from field: string artifact_id = 5;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string workbook_version_id = 6;
   */ _define_property(this, "workbookVersionId", ""), /**
   * Empty = unmapped (UNAVAILABLE). Otherwise a JSON object.
   *
   * @generated from field: string mapping_json = 7;
   */ _define_property(this, "mappingJson", ""), /**
   * @generated from field: string actor = 8;
   */ _define_property(this, "actor", ""), /**
   * Empty preserves the legacy artifact binding.
   *
   * @generated from field: string binding_kind = 9;
   */ _define_property(this, "bindingKind", ""), /**
   * @generated from field: string shirohige_document_id = 10;
   */ _define_property(this, "shirohigeDocumentId", ""), /**
   * @generated from field: string volume_document_id = 11;
   */ _define_property(this, "volumeDocumentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegisterPricingWorkbookRequest, "runtime", proto3);
_define_property(RegisterPricingWorkbookRequest, "typeName", "mono.datagateway.v1.RegisterPricingWorkbookRequest");
_define_property(RegisterPricingWorkbookRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "workbook_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "workbook_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "mapping_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "binding_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "shirohige_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "volume_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegisterPricingWorkbookResponse
 */ export class RegisterPricingWorkbookResponse extends Message {
    static fromBinary(bytes, options) {
        return new RegisterPricingWorkbookResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegisterPricingWorkbookResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegisterPricingWorkbookResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegisterPricingWorkbookResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PricingWorkbook workbook = 1;
   */ _define_property(this, "workbook", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegisterPricingWorkbookResponse, "runtime", proto3);
_define_property(RegisterPricingWorkbookResponse, "typeName", "mono.datagateway.v1.RegisterPricingWorkbookResponse");
_define_property(RegisterPricingWorkbookResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workbook",
            kind: "message",
            T: PricingWorkbook
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SubmitPricingWorkbookRevisionRequest
 */ export class SubmitPricingWorkbookRevisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SubmitPricingWorkbookRevisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitPricingWorkbookRevisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitPricingWorkbookRevisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitPricingWorkbookRevisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string workbook_id = 3;
   */ _define_property(this, "workbookId", ""), /**
   * @generated from field: string revised_workbook_version_id = 4;
   */ _define_property(this, "revisedWorkbookVersionId", ""), /**
   * Required for a MAPPED workbook; ignored for an UNAVAILABLE one.
   *
   * @generated from field: string proposed_diff_json = 5;
   */ _define_property(this, "proposedDiffJson", ""), /**
   * @generated from field: string proposal_id = 6;
   */ _define_property(this, "proposalId", ""), /**
   * @generated from field: string actor = 7;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitPricingWorkbookRevisionRequest, "runtime", proto3);
_define_property(SubmitPricingWorkbookRevisionRequest, "typeName", "mono.datagateway.v1.SubmitPricingWorkbookRevisionRequest");
_define_property(SubmitPricingWorkbookRevisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workbook_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "revised_workbook_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "proposed_diff_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "proposal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SubmitPricingWorkbookRevisionResponse
 */ export class SubmitPricingWorkbookRevisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SubmitPricingWorkbookRevisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitPricingWorkbookRevisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitPricingWorkbookRevisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitPricingWorkbookRevisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PricingWorkbook workbook = 1;
   */ _define_property(this, "workbook", void 0), /**
   * Unset when the workbook is UNAVAILABLE.
   *
   * @generated from field: mono.datagateway.v1.PricingReconciliationProposal proposal = 2;
   */ _define_property(this, "proposal", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitPricingWorkbookRevisionResponse, "runtime", proto3);
_define_property(SubmitPricingWorkbookRevisionResponse, "typeName", "mono.datagateway.v1.SubmitPricingWorkbookRevisionResponse");
_define_property(SubmitPricingWorkbookRevisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workbook",
            kind: "message",
            T: PricingWorkbook
        },
        {
            no: 2,
            name: "proposal",
            kind: "message",
            T: PricingReconciliationProposal
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolvePricingReconciliationProposalRequest
 */ export class ResolvePricingReconciliationProposalRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolvePricingReconciliationProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolvePricingReconciliationProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolvePricingReconciliationProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolvePricingReconciliationProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string proposal_id = 3;
   */ _define_property(this, "proposalId", ""), /**
   * @generated from field: bool accept = 4;
   */ _define_property(this, "accept", false), /**
   * @generated from field: string actor = 5;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolvePricingReconciliationProposalRequest, "runtime", proto3);
_define_property(ResolvePricingReconciliationProposalRequest, "typeName", "mono.datagateway.v1.ResolvePricingReconciliationProposalRequest");
_define_property(ResolvePricingReconciliationProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "accept",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolvePricingReconciliationProposalResponse
 */ export class ResolvePricingReconciliationProposalResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolvePricingReconciliationProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolvePricingReconciliationProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolvePricingReconciliationProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolvePricingReconciliationProposalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PricingReconciliationProposal proposal = 1;
   */ _define_property(this, "proposal", void 0), /**
   * Set on accept: the scenario as written and its new snapshot.
   *
   * @generated from field: mono.datagateway.v1.ProposalPricingScenario scenario = 2;
   */ _define_property(this, "scenario", void 0), /**
   * @generated from field: mono.datagateway.v1.PricingScenarioVersion version = 3;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolvePricingReconciliationProposalResponse, "runtime", proto3);
_define_property(ResolvePricingReconciliationProposalResponse, "typeName", "mono.datagateway.v1.ResolvePricingReconciliationProposalResponse");
_define_property(ResolvePricingReconciliationProposalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal",
            kind: "message",
            T: PricingReconciliationProposal
        },
        {
            no: 2,
            name: "scenario",
            kind: "message",
            T: ProposalPricingScenario
        },
        {
            no: 3,
            name: "version",
            kind: "message",
            T: PricingScenarioVersion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPricingEvidenceRequest
 */ export class ListPricingEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPricingEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPricingEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPricingEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPricingEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 3;
   */ _define_property(this, "scenarioId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPricingEvidenceRequest, "runtime", proto3);
_define_property(ListPricingEvidenceRequest, "typeName", "mono.datagateway.v1.ListPricingEvidenceRequest");
_define_property(ListPricingEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPricingEvidenceResponse
 */ export class ListPricingEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPricingEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPricingEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPricingEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPricingEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.PricingScenarioVersion versions = 1;
   */ _define_property(this, "versions", []), /**
   * @generated from field: repeated mono.datagateway.v1.PricingWorkbook workbooks = 2;
   */ _define_property(this, "workbooks", []), /**
   * @generated from field: repeated mono.datagateway.v1.PricingReconciliationProposal proposals = 3;
   */ _define_property(this, "proposals", []), /**
   * @generated from field: repeated mono.datagateway.v1.PricingRateSelection active_selections = 4;
   */ _define_property(this, "activeSelections", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPricingEvidenceResponse, "runtime", proto3);
_define_property(ListPricingEvidenceResponse, "typeName", "mono.datagateway.v1.ListPricingEvidenceResponse");
_define_property(ListPricingEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: PricingScenarioVersion,
            repeated: true
        },
        {
            no: 2,
            name: "workbooks",
            kind: "message",
            T: PricingWorkbook,
            repeated: true
        },
        {
            no: 3,
            name: "proposals",
            kind: "message",
            T: PricingReconciliationProposal,
            repeated: true
        },
        {
            no: 4,
            name: "active_selections",
            kind: "message",
            T: PricingRateSelection,
            repeated: true
        }
    ]));
/**
 * LcatRegistryLink is one proposal.lcat_registry_links row.
 *
 * @generated from message mono.datagateway.v1.LcatRegistryLink
 */ export class LcatRegistryLink extends Message {
    static fromBinary(bytes, options) {
        return new LcatRegistryLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LcatRegistryLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LcatRegistryLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LcatRegistryLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string lcat_logical_key = 3;
   */ _define_property(this, "lcatLogicalKey", ""), /**
   * "" = none
   *
   * @generated from field: string entry_id = 5;
   */ _define_property(this, "entryId", ""), /**
   * 0 = none
   *
   * @generated from field: int32 entry_version = 6;
   */ _define_property(this, "entryVersion", 0), /**
   * "" = none
   *
   * @generated from field: string entry_vehicle_id = 7;
   */ _define_property(this, "entryVehicleId", ""), /**
   * EQUIVALENT|BROADER|NARROWER|VEHICLE_MISMATCH|REVIEW_NEEDED|UNMAPPED
   *
   * @generated from field: string mapping_status = 8;
   */ _define_property(this, "mappingStatus", ""), /**
   * none|no_vehicle|accepted_candidate|same_vehicle_exact|same_vehicle_rosetta|ambiguous|vehicle_mismatch|unmatched|manual
   *
   * @generated from field: string match_basis = 9;
   */ _define_property(this, "matchBasis", ""), /**
   * @generated from field: repeated string ambiguous_entry_ids = 10;
   */ _define_property(this, "ambiguousEntryIds", []), /**
   * ""|price_from_source_vehicle|remap|as_written_only
   *
   * @generated from field: string decision = 11;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string source_vehicle_id = 12;
   */ _define_property(this, "sourceVehicleId", ""), /**
   * @generated from field: string decision_reason = 13;
   */ _define_property(this, "decisionReason", ""), /**
   * @generated from field: string decided_by = 14;
   */ _define_property(this, "decidedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 15;
   */ _define_property(this, "decidedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp removed_at = 16;
   */ _define_property(this, "removedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp matched_at = 17;
   */ _define_property(this, "matchedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 18;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 19;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LcatRegistryLink, "runtime", proto3);
_define_property(LcatRegistryLink, "typeName", "mono.datagateway.v1.LcatRegistryLink");
_define_property(LcatRegistryLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "lcat_logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "entry_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "entry_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "mapping_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "match_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "ambiguous_entry_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 11,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "source_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "decision_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "removed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "matched_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLcatRegistryLinksRequest
 */ export class ListLcatRegistryLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLcatRegistryLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLcatRegistryLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLcatRegistryLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLcatRegistryLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLcatRegistryLinksRequest, "runtime", proto3);
_define_property(ListLcatRegistryLinksRequest, "typeName", "mono.datagateway.v1.ListLcatRegistryLinksRequest");
_define_property(ListLcatRegistryLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLcatRegistryLinksResponse
 */ export class ListLcatRegistryLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLcatRegistryLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLcatRegistryLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLcatRegistryLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLcatRegistryLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.LcatRegistryLink links = 1;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLcatRegistryLinksResponse, "runtime", proto3);
_define_property(ListLcatRegistryLinksResponse, "typeName", "mono.datagateway.v1.ListLcatRegistryLinksResponse");
_define_property(ListLcatRegistryLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: LcatRegistryLink,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LcatRegistryLinkSyncItem
 */ export class LcatRegistryLinkSyncItem extends Message {
    static fromBinary(bytes, options) {
        return new LcatRegistryLinkSyncItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LcatRegistryLinkSyncItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LcatRegistryLinkSyncItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LcatRegistryLinkSyncItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string lcat_logical_key = 1;
   */ _define_property(this, "lcatLogicalKey", ""), /**
   * @generated from field: string entry_id = 3;
   */ _define_property(this, "entryId", ""), /**
   * @generated from field: int32 entry_version = 4;
   */ _define_property(this, "entryVersion", 0), /**
   * @generated from field: string entry_vehicle_id = 5;
   */ _define_property(this, "entryVehicleId", ""), /**
   * @generated from field: string mapping_status = 6;
   */ _define_property(this, "mappingStatus", ""), /**
   * @generated from field: string match_basis = 7;
   */ _define_property(this, "matchBasis", ""), /**
   * @generated from field: repeated string ambiguous_entry_ids = 8;
   */ _define_property(this, "ambiguousEntryIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LcatRegistryLinkSyncItem, "runtime", proto3);
_define_property(LcatRegistryLinkSyncItem, "typeName", "mono.datagateway.v1.LcatRegistryLinkSyncItem");
_define_property(LcatRegistryLinkSyncItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "lcat_logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "entry_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "entry_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "mapping_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "match_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "ambiguous_entry_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SyncLcatRegistryLinksRequest
 */ export class SyncLcatRegistryLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new SyncLcatRegistryLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncLcatRegistryLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncLcatRegistryLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncLcatRegistryLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: repeated mono.datagateway.v1.LcatRegistryLinkSyncItem items = 4;
   */ _define_property(this, "items", []), /**
   * Every logical key currently in Section B (a superset of items' keys);
   * rows outside it get removed_at.
   *
   * @generated from field: repeated string present_keys = 5;
   */ _define_property(this, "presentKeys", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncLcatRegistryLinksRequest, "runtime", proto3);
_define_property(SyncLcatRegistryLinksRequest, "typeName", "mono.datagateway.v1.SyncLcatRegistryLinksRequest");
_define_property(SyncLcatRegistryLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "items",
            kind: "message",
            T: LcatRegistryLinkSyncItem,
            repeated: true
        },
        {
            no: 5,
            name: "present_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SyncLcatRegistryLinksResponse
 */ export class SyncLcatRegistryLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new SyncLcatRegistryLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncLcatRegistryLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncLcatRegistryLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncLcatRegistryLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.LcatRegistryLink links = 1;
   */ _define_property(this, "links", []), /**
   * @generated from field: int32 inserted = 2;
   */ _define_property(this, "inserted", 0), /**
   * @generated from field: int32 updated = 3;
   */ _define_property(this, "updated", 0), /**
   * @generated from field: int32 removed = 4;
   */ _define_property(this, "removed", 0), /**
   * Rows left untouched because of a decision or match_basis 'manual'.
   *
   * @generated from field: int32 preserved = 5;
   */ _define_property(this, "preserved", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncLcatRegistryLinksResponse, "runtime", proto3);
_define_property(SyncLcatRegistryLinksResponse, "typeName", "mono.datagateway.v1.SyncLcatRegistryLinksResponse");
_define_property(SyncLcatRegistryLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: LcatRegistryLink,
            repeated: true
        },
        {
            no: 2,
            name: "inserted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "removed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "preserved",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideLcatRegistryLinkRequest
 */ export class DecideLcatRegistryLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideLcatRegistryLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideLcatRegistryLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideLcatRegistryLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideLcatRegistryLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string lcat_logical_key = 3;
   */ _define_property(this, "lcatLogicalKey", ""), /**
   * required: price_from_source_vehicle|remap|as_written_only
   *
   * @generated from field: string decision = 4;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string source_vehicle_id = 5;
   */ _define_property(this, "sourceVehicleId", ""), /**
   * remap target
   *
   * @generated from field: string entry_id = 6;
   */ _define_property(this, "entryId", ""), /**
   * @generated from field: int32 entry_version = 7;
   */ _define_property(this, "entryVersion", 0), /**
   * @generated from field: string entry_vehicle_id = 8;
   */ _define_property(this, "entryVehicleId", ""), /**
   * remap only; defaults to EQUIVALENT
   *
   * @generated from field: string mapping_status = 9;
   */ _define_property(this, "mappingStatus", ""), /**
   * required for a decision
   *
   * @generated from field: string reason = 10;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string actor = 11;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideLcatRegistryLinkRequest, "runtime", proto3);
_define_property(DecideLcatRegistryLinkRequest, "typeName", "mono.datagateway.v1.DecideLcatRegistryLinkRequest");
_define_property(DecideLcatRegistryLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "lcat_logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "entry_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "entry_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "mapping_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DecideLcatRegistryLinkResponse
 */ export class DecideLcatRegistryLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideLcatRegistryLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideLcatRegistryLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideLcatRegistryLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideLcatRegistryLinkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LcatRegistryLink before = 1;
   */ _define_property(this, "before", void 0), /**
   * @generated from field: mono.datagateway.v1.LcatRegistryLink link = 2;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideLcatRegistryLinkResponse, "runtime", proto3);
_define_property(DecideLcatRegistryLinkResponse, "typeName", "mono.datagateway.v1.DecideLcatRegistryLinkResponse");
_define_property(DecideLcatRegistryLinkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "before",
            kind: "message",
            T: LcatRegistryLink
        },
        {
            no: 2,
            name: "link",
            kind: "message",
            T: LcatRegistryLink
        }
    ]));
/**
 * RateObservationRef is one rate observation as a Rate Book cell shows it.
 * There is no person-level field on it: PAY and contact-scoped rows are never
 * loaded.
 *
 * @generated from message mono.datagateway.v1.RateObservationRef
 */ export class RateObservationRef extends Message {
    static fromBinary(bytes, options) {
        return new RateObservationRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateObservationRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateObservationRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateObservationRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string observation_id = 1;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0), /**
   * BILLED|SUBK_AGREED|AWARDED|CEILING|FLOOR|PROPOSED|INFERRED (never PAY)
   *
   * @generated from field: string observation_type = 3;
   */ _define_property(this, "observationType", ""), /**
   * decimal string
   *
   * @generated from field: string amount = 4;
   */ _define_property(this, "amount", ""), /**
   * @generated from field: string rate_unit = 5;
   */ _define_property(this, "rateUnit", ""), /**
   * @generated from field: string burden_basis = 6;
   */ _define_property(this, "burdenBasis", ""), /**
   * @generated from field: string company_profile_id = 7;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string company_name = 8;
   */ _define_property(this, "companyName", ""), /**
   * coalesce(observation, entry, generation) vehicle (S0)
   *
   * @generated from field: string effective_vehicle_id = 9;
   */ _define_property(this, "effectiveVehicleId", ""), /**
   * @generated from field: string vehicle_name = 10;
   */ _define_property(this, "vehicleName", ""), /**
   * verbatim
   *
   * @generated from field: string period_label = 11;
   */ _define_property(this, "periodLabel", ""), /**
   * YYYY-MM-DD or ""
   *
   * @generated from field: string period_start = 12;
   */ _define_property(this, "periodStart", ""), /**
   * @generated from field: string period_end = 13;
   */ _define_property(this, "periodEnd", ""), /**
   * as_of or created_at, YYYY-MM-DD
   *
   * @generated from field: string evidence_date = 14;
   */ _define_property(this, "evidenceDate", ""), /**
   * "billed FY26 · OMEGA mod P00007"; never a person's name
   *
   * @generated from field: string source_label = 15;
   */ _define_property(this, "sourceLabel", ""), /**
   * ours|teammate|competitor|other
   *
   * @generated from field: string role = 16;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string confidence = 17;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: bool cross_vehicle = 18;
   */ _define_property(this, "crossVehicle", false), /**
   * overlap|label|evidence_date|nearest
   *
   * @generated from field: string period_match = 19;
   */ _define_property(this, "periodMatch", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateObservationRef, "runtime", proto3);
_define_property(RateObservationRef, "typeName", "mono.datagateway.v1.RateObservationRef");
_define_property(RateObservationRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "effective_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "period_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "period_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "evidence_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "cross_vehicle",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 19,
            name: "period_match",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RateBookSuggestionInput
 */ export class RateBookSuggestionInput extends Message {
    static fromBinary(bytes, options) {
        return new RateBookSuggestionInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateBookSuggestionInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateBookSuggestionInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateBookSuggestionInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string observation_id = 1;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string observation_type = 3;
   */ _define_property(this, "observationType", ""), /**
   * @generated from field: string amount = 4;
   */ _define_property(this, "amount", ""), /**
   * @generated from field: string role = 5;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string exclude_reason = 6;
   */ _define_property(this, "excludeReason", ""), /**
   * @generated from field: string company_name = 7;
   */ _define_property(this, "companyName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateBookSuggestionInput, "runtime", proto3);
_define_property(RateBookSuggestionInput, "typeName", "mono.datagateway.v1.RateBookSuggestionInput");
_define_property(RateBookSuggestionInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "exclude_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * RateBookSuggestion is the pure output of rules S0-S7 for one category x period.
 *
 * @generated from message mono.datagateway.v1.RateBookSuggestion
 */ export class RateBookSuggestion extends Message {
    static fromBinary(bytes, options) {
        return new RateBookSuggestion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateBookSuggestion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateBookSuggestion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateBookSuggestion, a, b);
    }
    constructor(data){
        super(), /**
   * "" = none
   *
   * @generated from field: string amount = 1;
   */ _define_property(this, "amount", ""), /**
   * R1_PAST_24M_LOWEST_EXECUTED|R1_NO_EXECUTED_USE_CEILING|R2_FUTURE_CEILING|NONE
   *
   * @generated from field: string rule_id = 2;
   */ _define_property(this, "ruleId", ""), /**
   * ratebook.RuleLabel(rule_id)
   *
   * @generated from field: string rule_label = 3;
   */ _define_property(this, "ruleLabel", ""), /**
   * R1 fallback, and INFERRED-only (S5)
   *
   * @generated from field: bool requires_choice = 4;
   */ _define_property(this, "requiresChoice", false), /**
   * @generated from field: string explanation = 5;
   */ _define_property(this, "explanation", ""), /**
   * @generated from field: repeated mono.datagateway.v1.RateBookSuggestionInput inputs = 6;
   */ _define_property(this, "inputs", []), /**
   * ratebook version + "+prp-s0s7-v1"
   *
   * @generated from field: string helper_version = 7;
   */ _define_property(this, "helperVersion", ""), /**
   * hex(sha256(canonical json of category, period, amount, rule, helper version, sorted inputs))[:32]
   *
   * @generated from field: string token = 8;
   */ _define_property(this, "token", ""), /**
   * e.g. BURDEN_NOT_STATED, OUTSIDE_LOOKBACK, MULTIPLE_CEILING_GENERATIONS
   *
   * @generated from field: repeated string warnings = 9;
   */ _define_property(this, "warnings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateBookSuggestion, "runtime", proto3);
_define_property(RateBookSuggestion, "typeName", "mono.datagateway.v1.RateBookSuggestion");
_define_property(RateBookSuggestion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rule_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "requires_choice",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "explanation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "inputs",
            kind: "message",
            T: RateBookSuggestionInput,
            repeated: true
        },
        {
            no: 7,
            name: "helper_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RateBookCell
 */ export class RateBookCell extends Message {
    static fromBinary(bytes, options) {
        return new RateBookCell().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateBookCell().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateBookCell().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateBookCell, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string category_id = 1;
   */ _define_property(this, "categoryId", ""), /**
   * @generated from field: string period_key = 2;
   */ _define_property(this, "periodKey", ""), /**
   * @generated from field: mono.datagateway.v1.RateObservationRef ours = 3;
   */ _define_property(this, "ours", void 0), /**
   * @generated from field: mono.datagateway.v1.RateObservationRef teammate = 4;
   */ _define_property(this, "teammate", void 0), /**
   * @generated from field: mono.datagateway.v1.RateObservationRef competitor = 5;
   */ _define_property(this, "competitor", void 0), /**
   * no_history|unmapped|not_equivalent|as_written_only|needs_decision
   *
   * @generated from field: string ours_empty_reason = 6;
   */ _define_property(this, "oursEmptyReason", ""), /**
   * + no_teammates
   *
   * @generated from field: string teammate_empty_reason = 7;
   */ _define_property(this, "teammateEmptyReason", ""), /**
   * + no_competitors
   *
   * @generated from field: string competitor_empty_reason = 8;
   */ _define_property(this, "competitorEmptyReason", ""), /**
   * @generated from field: mono.datagateway.v1.RateBookSuggestion suggestion = 9;
   */ _define_property(this, "suggestion", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateBookCell, "runtime", proto3);
_define_property(RateBookCell, "typeName", "mono.datagateway.v1.RateBookCell");
_define_property(RateBookCell, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "category_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "ours",
            kind: "message",
            T: RateObservationRef
        },
        {
            no: 4,
            name: "teammate",
            kind: "message",
            T: RateObservationRef
        },
        {
            no: 5,
            name: "competitor",
            kind: "message",
            T: RateObservationRef
        },
        {
            no: 6,
            name: "ours_empty_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "teammate_empty_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "competitor_empty_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "suggestion",
            kind: "message",
            T: RateBookSuggestion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RateBookRowObservations
 */ export class RateBookRowObservations extends Message {
    static fromBinary(bytes, options) {
        return new RateBookRowObservations().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateBookRowObservations().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateBookRowObservations().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateBookRowObservations, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string category_id = 1;
   */ _define_property(this, "categoryId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.RateObservationRef observations = 2;
   */ _define_property(this, "observations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateBookRowObservations, "runtime", proto3);
_define_property(RateBookRowObservations, "typeName", "mono.datagateway.v1.RateBookRowObservations");
_define_property(RateBookRowObservations, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "category_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "observations",
            kind: "message",
            T: RateObservationRef,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ComputePricingRateBookRequest
 */ export class ComputePricingRateBookRequest extends Message {
    static fromBinary(bytes, options) {
        return new ComputePricingRateBookRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComputePricingRateBookRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComputePricingRateBookRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComputePricingRateBookRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 3;
   */ _define_property(this, "scenarioId", ""), /**
   * rate-card categories (non-removed)
   *
   * @generated from field: repeated mono.datagateway.v1.ComputePricingRateBookRequest.Target targets = 4;
   */ _define_property(this, "targets", []), /**
   * from rateCard.periods
   *
   * @generated from field: repeated mono.datagateway.v1.ComputePricingRateBookRequest.Period periods = 5;
   */ _define_property(this, "periods", []), /**
   * YYYY-MM-DD; server date when ""
   *
   * @generated from field: string as_of_date = 6;
   */ _define_property(this, "asOfDate", ""), /**
   * @generated from field: string proposal_vehicle_id = 7;
   */ _define_property(this, "proposalVehicleId", ""), /**
   * @generated from field: repeated string teammate_company_profile_ids = 8;
   */ _define_property(this, "teammateCompanyProfileIds", []), /**
   * @generated from field: repeated string competitor_company_profile_ids = 9;
   */ _define_property(this, "competitorCompanyProfileIds", []), /**
   * rail (single target)
   *
   * @generated from field: bool include_row_observations = 10;
   */ _define_property(this, "includeRowObservations", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComputePricingRateBookRequest, "runtime", proto3);
_define_property(ComputePricingRateBookRequest, "typeName", "mono.datagateway.v1.ComputePricingRateBookRequest");
_define_property(ComputePricingRateBookRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "targets",
            kind: "message",
            T: ComputePricingRateBookRequest_Target,
            repeated: true
        },
        {
            no: 5,
            name: "periods",
            kind: "message",
            T: ComputePricingRateBookRequest_Period,
            repeated: true
        },
        {
            no: 6,
            name: "as_of_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "proposal_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "teammate_company_profile_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "competitor_company_profile_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "include_row_observations",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ComputePricingRateBookRequest.Target
 */ export class ComputePricingRateBookRequest_Target extends Message {
    static fromBinary(bytes, options) {
        return new ComputePricingRateBookRequest_Target().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComputePricingRateBookRequest_Target().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComputePricingRateBookRequest_Target().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComputePricingRateBookRequest_Target, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string category_id = 1;
   */ _define_property(this, "categoryId", ""), /**
   * @generated from field: string lcat_logical_key = 2;
   */ _define_property(this, "lcatLogicalKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComputePricingRateBookRequest_Target, "runtime", proto3);
_define_property(ComputePricingRateBookRequest_Target, "typeName", "mono.datagateway.v1.ComputePricingRateBookRequest.Target");
_define_property(ComputePricingRateBookRequest_Target, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "category_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "lcat_logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ComputePricingRateBookRequest.Period
 */ export class ComputePricingRateBookRequest_Period extends Message {
    static fromBinary(bytes, options) {
        return new ComputePricingRateBookRequest_Period().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComputePricingRateBookRequest_Period().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComputePricingRateBookRequest_Period().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComputePricingRateBookRequest_Period, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string period_key = 1;
   */ _define_property(this, "periodKey", ""), /**
   * @generated from field: string start_date = 2;
   */ _define_property(this, "startDate", ""), /**
   * @generated from field: string end_date = 3;
   */ _define_property(this, "endDate", ""), /**
   * @generated from field: string label = 4;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComputePricingRateBookRequest_Period, "runtime", proto3);
_define_property(ComputePricingRateBookRequest_Period, "typeName", "mono.datagateway.v1.ComputePricingRateBookRequest.Period");
_define_property(ComputePricingRateBookRequest_Period, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ComputePricingRateBookResponse
 */ export class ComputePricingRateBookResponse extends Message {
    static fromBinary(bytes, options) {
        return new ComputePricingRateBookResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComputePricingRateBookResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComputePricingRateBookResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComputePricingRateBookResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RateBookCell cells = 1;
   */ _define_property(this, "cells", []), /**
   * @generated from field: repeated mono.datagateway.v1.RateBookRowObservations row_observations = 2;
   */ _define_property(this, "rowObservations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComputePricingRateBookResponse, "runtime", proto3);
_define_property(ComputePricingRateBookResponse, "typeName", "mono.datagateway.v1.ComputePricingRateBookResponse");
_define_property(ComputePricingRateBookResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "cells",
            kind: "message",
            T: RateBookCell,
            repeated: true
        },
        {
            no: 2,
            name: "row_observations",
            kind: "message",
            T: RateBookRowObservations,
            repeated: true
        }
    ]));
/**
 * PRP-13: SetPricingRate. zou validates (S6, token, gates); this writes.
 *
 * @generated from message mono.datagateway.v1.SetPricingRateRequest
 */ export class SetPricingRateRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetPricingRateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPricingRateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPricingRateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPricingRateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 3;
   */ _define_property(this, "scenarioId", ""), /**
   * @generated from field: string category_id = 4;
   */ _define_property(this, "categoryId", ""), /**
   * @generated from field: string period_key = 5;
   */ _define_property(this, "periodKey", ""), /**
   * decimal; "" clears the rate
   *
   * @generated from field: string value = 6;
   */ _define_property(this, "value", ""), /**
   * rates[p].metadata.using
   *
   * @generated from field: string using_metadata_json = 7;
   */ _define_property(this, "usingMetadataJson", ""), /**
   * rates[p].metadata.suggestionAtChoice ("" = none)
   *
   * @generated from field: string suggestion_at_choice_json = 8;
   */ _define_property(this, "suggestionAtChoiceJson", ""), /**
   * Observation basis only: the pin written in the same transaction.
   *
   * @generated from field: string observation_id = 9;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: int32 observation_version = 10;
   */ _define_property(this, "observationVersion", 0), /**
   * @generated from field: string selected_amount = 11;
   */ _define_property(this, "selectedAmount", ""), /**
   * @generated from field: string assumptions_json = 12;
   */ _define_property(this, "assumptionsJson", ""), /**
   * RFC3339Nano; required
   *
   * @generated from field: string expected_updated_at = 13;
   */ _define_property(this, "expectedUpdatedAt", ""), /**
   * @generated from field: string actor = 14;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPricingRateRequest, "runtime", proto3);
_define_property(SetPricingRateRequest, "typeName", "mono.datagateway.v1.SetPricingRateRequest");
_define_property(SetPricingRateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "category_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "using_metadata_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "suggestion_at_choice_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "observation_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "selected_amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "assumptions_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "expected_updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetPricingRateResponse
 */ export class SetPricingRateResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetPricingRateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPricingRateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPricingRateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPricingRateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * RFC3339Nano
   *
   * @generated from field: string updated_at = 1;
   */ _define_property(this, "updatedAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPricingRateResponse, "runtime", proto3);
_define_property(SetPricingRateResponse, "typeName", "mono.datagateway.v1.SetPricingRateResponse");
_define_property(SetPricingRateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Serializes with all other pricing writes under the project lock.
 *
 * @generated from message mono.datagateway.v1.SetPrimaryPricingScenarioRequest
 */ export class SetPrimaryPricingScenarioRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetPrimaryPricingScenarioRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPrimaryPricingScenarioRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPrimaryPricingScenarioRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPrimaryPricingScenarioRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 3;
   */ _define_property(this, "scenarioId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPrimaryPricingScenarioRequest, "runtime", proto3);
_define_property(SetPrimaryPricingScenarioRequest, "typeName", "mono.datagateway.v1.SetPrimaryPricingScenarioRequest");
_define_property(SetPrimaryPricingScenarioRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetPrimaryPricingScenarioResponse
 */ export class SetPrimaryPricingScenarioResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetPrimaryPricingScenarioResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPrimaryPricingScenarioResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPrimaryPricingScenarioResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPrimaryPricingScenarioResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalPricingScenario scenario = 1;
   */ _define_property(this, "scenario", void 0), /**
   * @generated from field: bool changed = 2;
   */ _define_property(this, "changed", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPrimaryPricingScenarioResponse, "runtime", proto3);
_define_property(SetPrimaryPricingScenarioResponse, "typeName", "mono.datagateway.v1.SetPrimaryPricingScenarioResponse");
_define_property(SetPrimaryPricingScenarioResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scenario",
            kind: "message",
            T: ProposalPricingScenario
        },
        {
            no: 2,
            name: "changed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * PRP-33: scoped policy and explicit Using reapplication in one CAS transaction.
 *
 * @generated from message mono.datagateway.v1.SetPricingAdjustmentRequest
 */ export class SetPricingAdjustmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetPricingAdjustmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPricingAdjustmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPricingAdjustmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPricingAdjustmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 3;
   */ _define_property(this, "scenarioId", ""), /**
   * @generated from field: string scope = 4;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: string period_key = 5;
   */ _define_property(this, "periodKey", ""), /**
   * @generated from field: string lcat_logical_key = 6;
   */ _define_property(this, "lcatLogicalKey", ""), /**
   * @generated from field: string pct = 7;
   */ _define_property(this, "pct", ""), /**
   * @generated from field: string reason = 8;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: bool reapply_to_using = 9;
   */ _define_property(this, "reapplyToUsing", false), /**
   * @generated from field: string expected_updated_at = 10;
   */ _define_property(this, "expectedUpdatedAt", ""), /**
   * @generated from field: string actor = 11;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPricingAdjustmentRequest, "runtime", proto3);
_define_property(SetPricingAdjustmentRequest, "typeName", "mono.datagateway.v1.SetPricingAdjustmentRequest");
_define_property(SetPricingAdjustmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "lcat_logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "pct",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "reapply_to_using",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "expected_updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetPricingAdjustmentResponse
 */ export class SetPricingAdjustmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetPricingAdjustmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPricingAdjustmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPricingAdjustmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPricingAdjustmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string updated_at = 1;
   */ _define_property(this, "updatedAt", ""), /**
   * empty when cleared
   *
   * @generated from field: string adjustment_json = 2;
   */ _define_property(this, "adjustmentJson", ""), /**
   * @generated from field: int32 rows_governed = 3;
   */ _define_property(this, "rowsGoverned", 0), /**
   * @generated from field: int32 using_reapplied = 4;
   */ _define_property(this, "usingReapplied", 0), /**
   * @generated from field: int32 using_now_stale = 5;
   */ _define_property(this, "usingNowStale", 0), /**
   * @generated from field: string entry_id = 6;
   */ _define_property(this, "entryId", ""), /**
   * @generated from field: string before_pct = 7;
   */ _define_property(this, "beforePct", ""), /**
   * category_id@period_key
   *
   * @generated from field: map<string, mono.datagateway.v1.PricingAdjustmentRateChange> rewritten = 8;
   */ _define_property(this, "rewritten", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPricingAdjustmentResponse, "runtime", proto3);
_define_property(SetPricingAdjustmentResponse, "typeName", "mono.datagateway.v1.SetPricingAdjustmentResponse");
_define_property(SetPricingAdjustmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "adjustment_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rows_governed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "using_reapplied",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "using_now_stale",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "before_pct",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "rewritten",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "message",
                T: PricingAdjustmentRateChange
            }
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PricingAdjustmentRateChange
 */ export class PricingAdjustmentRateChange extends Message {
    static fromBinary(bytes, options) {
        return new PricingAdjustmentRateChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingAdjustmentRateChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingAdjustmentRateChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingAdjustmentRateChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string from_amount = 1;
   */ _define_property(this, "fromAmount", ""), /**
   * @generated from field: string to_amount = 2;
   */ _define_property(this, "toAmount", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingAdjustmentRateChange, "runtime", proto3);
_define_property(PricingAdjustmentRateChange, "typeName", "mono.datagateway.v1.PricingAdjustmentRateChange");
_define_property(PricingAdjustmentRateChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "from_amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "to_amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Records a successful document apply. expected_updated_at prevents concurrent
 * fills or an unbind from silently overwriting a newer binding state.
 *
 * @generated from message mono.datagateway.v1.UpdatePricingWorkbookFillRequest
 */ export class UpdatePricingWorkbookFillRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePricingWorkbookFillRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePricingWorkbookFillRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePricingWorkbookFillRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePricingWorkbookFillRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string workbook_id = 3;
   */ _define_property(this, "workbookId", ""), /**
   * @generated from field: string last_filled_version_id = 4;
   */ _define_property(this, "lastFilledVersionId", ""), /**
   * @generated from field: string last_filled_from_version_id = 5;
   */ _define_property(this, "lastFilledFromVersionId", ""), /**
   * @generated from field: string actor = 6;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 7;
   */ _define_property(this, "expectedUpdatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePricingWorkbookFillRequest, "runtime", proto3);
_define_property(UpdatePricingWorkbookFillRequest, "typeName", "mono.datagateway.v1.UpdatePricingWorkbookFillRequest");
_define_property(UpdatePricingWorkbookFillRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workbook_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "last_filled_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "last_filled_from_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "expected_updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdatePricingWorkbookFillResponse
 */ export class UpdatePricingWorkbookFillResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePricingWorkbookFillResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePricingWorkbookFillResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePricingWorkbookFillResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePricingWorkbookFillResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PricingWorkbook workbook = 1;
   */ _define_property(this, "workbook", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePricingWorkbookFillResponse, "runtime", proto3);
_define_property(UpdatePricingWorkbookFillResponse, "typeName", "mono.datagateway.v1.UpdatePricingWorkbookFillResponse");
_define_property(UpdatePricingWorkbookFillResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workbook",
            kind: "message",
            T: PricingWorkbook
        }
    ]));
